import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { featureToggleGuard } from 'ish-core/feature-toggle.module';
import { authGuard } from 'ish-core/guards/auth.guard';

/**
 * CUSTOMIZATION: Quick Order page is out of MVP Now — legacy paths redirect home
 * via `/custom-quickorder` → home. Cart direct-order form may still use the stock
 * `quickorder` feature toggle separately.
 */
const routes: Routes = [
  {
    path: 'quick-order',
    redirectTo: '/home',
    pathMatch: 'full',
  },
  // Keep lazy path available behind feature flag for non-Presidio / fallback (unused when redirected)
  {
    path: 'quick-order-legacy',
    loadChildren: () => import('./quickorder/quickorder-page.module').then(m => m.QuickorderPageModule),
    canActivate: [authGuard, featureToggleGuard],
    data: {
      feature: 'quickorder',
      breadcrumbData: [{ key: 'quickorder.page.breadcrumb' }],
      meta: {
        title: 'quickorder.page.breadcrumb',
        robots: 'noindex, nofollow',
      },
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
})
export class QuickorderRoutingModule {}
